import React from "react";

export default function Privacy() {
    return (
        <div className="bg-white py-20" data-testid="privacy-page">
            <div className="max-w-3xl mx-auto px-6 sm:px-8 prose prose-slate">
                <div className="uppercase tracking-[0.25em] text-xs font-semibold text-slate-700 mb-3">Legal</div>
                <h1 className="font-serif text-4xl sm:text-5xl text-navy-900">Privacy Policy</h1>
                <p className="text-slate-600 mt-6 text-lg leading-relaxed">
                    AnnuityReviewPro values your privacy. We collect only the information necessary to provide you with a personalized annuity review.
                </p>
                <h2 className="font-serif text-2xl text-navy-900 mt-10">Information we collect</h2>
                <p className="text-slate-600 mt-3 leading-relaxed">
                    Contact details (name, email, phone), basic information about your annuity contract, and any documents you choose to upload.
                </p>
                <h2 className="font-serif text-2xl text-navy-900 mt-10">How we use it</h2>
                <p className="text-slate-600 mt-3 leading-relaxed">
                    Information is used solely to prepare your review and contact you about it. We do not sell or share your data with third-party marketers.
                </p>
                <h2 className="font-serif text-2xl text-navy-900 mt-10">Storage & security</h2>
                <p className="text-slate-600 mt-3 leading-relaxed">
                    Submissions are stored in encrypted infrastructure. Documents are accessible only to authorized personnel.
                </p>
                <h2 className="font-serif text-2xl text-navy-900 mt-10">Contact</h2>
                <p className="text-slate-600 mt-3 leading-relaxed">
                    Questions about this policy? Email <a className="text-navy-900 underline" href="mailto:reviews@yourannuityreview.com">reviews@yourannuityreview.com</a>.
                </p>
            </div>
        </div>
    );
}
